var _path, _path2, _path3, _line, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "flex-shrink-0 size-3.5 text-gray-400 dark:text-neutral-600",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hs-password-active:hidden",
    d: "M9.88 9.88a3 3 0 1 0 4.24 4.24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "hs-password-active:hidden",
    d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "hs-password-active:hidden",
    d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "hs-password-active:hidden",
    x1: 2,
    x2: 22,
    y1: 2,
    y2: 22
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "hidden hs-password-active:block",
    d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "hidden hs-password-active:block",
    cx: 12,
    cy: 12,
    r: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eyeClose.490360a68c70080ba946e2d1790fc22b.svg";
export { ForwardRef as ReactComponent };